import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "file-info"
}
const _hoisted_2 = { class: "file-info__header" }
const _hoisted_3 = { class: "file-info__header-left" }
const _hoisted_4 = { class: "file-info__field" }
const _hoisted_5 = { class: "file-info__field-name" }
const _hoisted_6 = { class: "file-info__field" }
const _hoisted_7 = { class: "file-info__field-name" }
const _hoisted_8 = { class: "file-info__field-value" }
const _hoisted_9 = { class: "file-info__field" }
const _hoisted_10 = { class: "file-info__field-name" }
const _hoisted_11 = { class: "file-info__field-value" }
const _hoisted_12 = {
  key: 0,
  class: "file-info__field"
}
const _hoisted_13 = { class: "file-info__field-name" }
const _hoisted_14 = { class: "file-info__field" }
const _hoisted_15 = { class: "file-info__field-name" }
const _hoisted_16 = { class: "file-info__field-value" }
const _hoisted_17 = {
  key: 1,
  class: "file-info__field file-info__field--col"
}
const _hoisted_18 = {
  class: "file-info__field-name",
  style: { color: '#4D4D4D' }
}
const _hoisted_19 = { class: "file-info__field-value-col-time" }
const _hoisted_20 = { class: "file-info__field-value-col-name" }
const _hoisted_21 = { class: "file-info__field-value-col-action" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "file-info__header-right"
}
const _hoisted_25 = { class: "file-info__add-lists" }
const _hoisted_26 = { class: "file-info__add-lists-text" }
const _hoisted_27 = { class: "file-info__lists" }
const _hoisted_28 = { class: "file-info__lists-item-name" }
const _hoisted_29 = {
  key: 0,
  class: "file-info__header-permition"
}
const _hoisted_30 = { class: "file-info__header-permition-label" }

import BaseModal from "@/components/common/modal/BaseModal.vue";
import {
  computed,
  inject,
  nextTick,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "vue";
import { AnalyticsListItem} from "@/store/clients";
import moment from "moment";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import { AnalyticsApi } from "@/ api/AnalyticsApi";
import FileInfoListSelect from "../FileInfoListSelect.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import {
  FileInfoContainer,
  FolderInfoContainer,
  TagSignable,
} from "@/models/interfaces/file/file-model";
import AppTabsOld from "@/components/ui-kit/tabs/AppTabsOld.vue";
import FileInput from "../FileInput.vue";
import FilePermitionsTab from "../permitions/FilePermitionsTab.vue";
import AppHashtag from "@/components/ui-kit/hashtag/AppHashtag.vue";
import { i18n } from "@/i18n";
import { formatChangelogText } from "@/utils/textHelpers";

type Props = {
  ruleAccess: number;
  clientId: number;
  projectId: number;
};

interface ChildEventData {
  type: string;
  data: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FileInfoModal',
  props: {
    ruleAccess: { default: 0 },
    clientId: { default: 0 },
    projectId: { default: 0 }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const $modal = ref<typeof BaseModal | null>(null);
const isLoading = ref(false);
const fileInfo = ref<FileInfoContainer | FolderInfoContainer | null>(null);
const filePermitionsInfo = ref<FileInfoContainer | FolderInfoContainer | null>(null);
const parentFolder = ref();
const showAllChanges = ref(false);
const showAddListSelect = ref(false);
const lists = ref<AnalyticsListItem[]>([]);
const typeModalInfo = ref();
const isAdmin = inject("isAdmin");
const entityEditable = ref(false);
const effectiveRuleAccess = computed(
  () => entityEditable.value ? 2 : isAdmin? 2: 0,
);
const hasLimitedAccess = computed(() => effectiveRuleAccess.value == 0);
let tabs = [
  { id: 0, title: String(i18n.global.t("file_folder_information")), slotName: "info" },
  { id: 1, title: String(i18n.global.t("file_access_rights")), slotName: "permitions" },
];
let isNameEditable = ref(false);
const $createEditFileModal = ref<typeof AppResizableDropdown | null>(null);
const isActive = ref(false);
const isDropdownOpened = ref(false);

const closeAddClientDropdown = () => {
  $createEditFileModal.value?.close();
};

const editName = () => {
  if (effectiveRuleAccess.value !== 2) return;

  isNameEditable.value = true;

  if (inputRef.value) {
    inputRef.value.focus();
  }
};

const onNameFocus = () => {
  if (effectiveRuleAccess.value === 2) {
    isNameEditable.value = true;
  }
};

const openDropdown = () => {
  isDropdownOpened.value = true;
};

const closeDropdown = () => {
  isDropdownOpened.value = false;
};

const save = () => {
  $modal.value?.onClose();
};

const blurInput = () => {
  isNameEditable.value = false;
};

const cancelEdit = async () => {
  isNameEditable.value = false;

  inputRef.value?.blur();

  await nextTick(() => {});
};

const closeList = async () => {
  showAddListSelect.value = false;

  $createEditFileModal.value?.close();

  await nextTick(() => {});
};

onMounted(() => {
  window.addEventListener("keydown", handleEsc, true);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEsc, true);
});

const handleEsc = async (e: KeyboardEvent) => {
  if (e.key !== "Escape") return;

  if (document.querySelector('.app-select__dropdown')) return;

  if (isNameEditable.value) {
    e.stopImmediatePropagation();
    cancelEdit();
    return;
  }

  if (showAddListSelect.value) {
    e.stopImmediatePropagation();
    await closeList();
    return;
  }

  if (isDropdownOpened.value) return;
  if (!isActive.value) return;

  e.stopPropagation();
  $modal.value?.onClose();
};

const closeBaseModal = () => {
  isActive.value = false;
};

const activeTab = ref(tabs[0].id);
const inputRef = ref<InstanceType<typeof FileInput> | null>(null);

const emitToParent =
  inject<(eventData: ChildEventData) => void>("childEventEmitter");

const createDate = computed(() => {
  if (!fileInfo.value || !fileInfo.value.CreateTime) {
    return "";
  }

  return `${moment(fileInfo.value.CreateTime).format("HH:mm DD.MM.YYYY")}${
    fileInfo.value.Creator ? ` [${fileInfo.value.Creator}]` : ""
  }`;
});

const rename = (name: string) => {
  if (emitToParent) {
    if (typeModalInfo.value === "file") {
      emitToParent({
        type: "renameFile",
        data: {
          dir: parentFolder.value,
          file: fileInfo.value?.Id,
          value: name,
          info: true,
        },
      });
    }
    if (
      typeModalInfo.value === "folder" ||
      typeModalInfo.value === "parentFolder"
    ) {
      emitToParent({
        type: "rename",
        data: { dir: fileInfo.value?.Id, value: name, info: true },
      });
    }
  }
};

const getDate = (date: string) => {
  return moment(date).format("HH:mm DD.MM.YYYY");
};

const updateAnalyticLists = async () => {
  if (!fileInfo.value) return;

  fileInfo.value.AnalyticsLists = (
    await AnalyticsApi.getListOfElement(fileInfo.value.Id, 4)
  ).Lists;
};

const onDeleteList = async (list: AnalyticsListItem) => {
  if (!fileInfo.value) return;
  await AnalyticsApi.removeElementIntoList(list.Id, 4, fileInfo?.value?.Id);
  fileInfo.value.AnalyticsLists.splice(
    fileInfo.value?.AnalyticsLists.findIndex(
      (listFile) => listFile.Id === list.Id,
    ),
    1,
  );
};

const onOpen = async (
  container: FileInfoContainer | FolderInfoContainer,
  type: string,
  parentFolderId?: number,
  tags?: TagSignable[],
  editable?: boolean,
) => {
  try {
    isLoading.value = true;
    $modal.value?.onOpen();
    isActive.value = true;
    typeModalInfo.value = type;
    const containerEditable = (
      container as (FileInfoContainer | FolderInfoContainer) & {
        Editable?: boolean;
      }
    ).Editable;
    entityEditable.value = editable ?? containerEditable === true;
    fileInfo.value = container;
    filePermitionsInfo.value = {
      ...container,
      Changelog: [...container.GroupChanges].sort(
        (a, b) => new Date(b.Time).getTime() - new Date(a.Time).getTime(),
      ),
    };
    if (type === "file") {
      parentFolder.value = parentFolderId;
      fileInfo.value.Changelog = fileInfo.value.FileChanges.concat(
        fileInfo.value.TagChanges
      ).sort((a, b) => new Date(b.Time).getTime() - new Date(a.Time).getTime());

      fileInfo.value.AnalyticsLists = (
        await AnalyticsApi.getListOfElement(fileInfo.value.Id, 4)
      ).Lists;

      tabs = [
        { id: 0, title: String(i18n.global.t("file_information")), slotName: "info" },
        { id: 1, title: String(i18n.global.t("file_access_rights")), slotName: "permitions" },
      ];
    } else {
      fileInfo.value.Changelog = fileInfo.value.FolderChanges.concat(
        fileInfo.value.TagChanges
      ).sort((a, b) => new Date(b.Time).getTime() - new Date(a.Time).getTime());

      tabs = [
        { id: 0, title: String(i18n.global.t("file_folder_information")), slotName: "info" },
        { id: 1, title: String(i18n.global.t("file_access_rights")), slotName: "permitions" },
      ];
    }

    if (tags) fileInfo.value.Tags = tags;
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

watch(showAddListSelect, async () => {
  const list = await AnalyticsApi.getLists(
    "",
    0,
    4,
    fileInfo.value?.Id as number,
  );

  lists.value = list.Lists;
});

__expose({ onOpen });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    "fullscreen-on-mobile": "",
    loading: isLoading.value,
    onOnClose: closeBaseModal,
    width: "900px",
    height: "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(AppTabsOld, {
        tabs: _unref(tabs),
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event))
      }, {
        info: _withCtx(() => [
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("file_info_name")) + ": ", 1),
                      _createVNode(FileInput, {
                        ref_key: "inputRef",
                        ref: inputRef,
                        modelValue: fileInfo.value.Name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileInfo.value.Name) = $event)),
                        type: "file",
                        onFocus: onNameFocus,
                        onEnter: rename,
                        onBlur: blurInput,
                        onKeydown: _withKeys(_withModifiers(cancelEdit, ["stop","prevent"]), ["esc"])
                      }, null, 8, ["modelValue", "onKeydown"]),
                      (
                    typeModalInfo.value !== 'parentFolder' &&
                    effectiveRuleAccess.value === 2
                  )
                        ? (_openBlock(), _createBlock(AppIcon, {
                            key: 0,
                            style: {"margin-left":"4px","margin-bottom":"2px"},
                            class: "file-item__option-icons-icon",
                            name: "edit-pencil",
                            width: "16px",
                            color: "#979797",
                            cursor: "pointer",
                            "hover-color": "#499259",
                            onClick: editName
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("file_info_size")) + ": ", 1),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(typeModalInfo.value == "file"
                    ? fileInfo.value?.Size
                    : fileInfo.value?.SizeDisplay), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("file_info_added")) + ": ", 1),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(createDate.value), 1)
                    ]),
                    (fileInfo.value?.Tags && fileInfo.value?.Tags.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("file_info_tags")) + ": ", 1),
                          _createVNode(AppHashtag, {
                            items: fileInfo.value?.Tags,
                            "selector-enabled": false,
                            type: "text"
                          }, null, 8, ["items"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("file_info_download_count")) + ": ", 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(fileInfo.value?.DownloadCount), 1)
                    ]),
                    (fileInfo.value?.Changelog?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t(typeModalInfo.value == "file"
                      ? "file_info_file_changes"
                      : "file_info_folder_changes")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showAllChanges.value
                    ? fileInfo.value.Changelog
                    : fileInfo.value.Changelog.slice(0, 4), (change, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "file-info__field-value-col",
                              key: change.Time
                            }, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(getDate(change.Time)) + " ", 1),
                              _createElementVNode("span", _hoisted_20, "[" + _toDisplayString(change.Changer) + "]", 1),
                              _createElementVNode("span", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formatChangelogText)(change.Text), (segment, segmentIndex) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: segmentIndex }, [
                                    (segment.italic)
                                      ? (_openBlock(), _createElementBlock("em", _hoisted_22, _toDisplayString(segment.text), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(segment.text), 1))
                                  ], 64))
                                }), 128))
                              ]),
                              (
                      !showAllChanges.value &&
                      fileInfo.value.Changelog.length > 4 &&
                      index === 3
                    )
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "file-info__field-value-col-show-more",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showAllChanges.value = true))
                                  }, _toDisplayString(_ctx.$t("permissions_more")) + " " + _toDisplayString(fileInfo.value.Changelog.length - 4), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (typeModalInfo.value == 'file')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(AppResizableDropdown, {
                            position: "left",
                            resizable: false,
                            "initial-width": 320,
                            "initial-height": 436,
                            "close-by-click-outside": false,
                            ref_key: "$createEditFileModal",
                            ref: $createEditFileModal,
                            name: "$createFileModal"
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppTooltip, {
                                text: _ctx.$t('file_info_add_to_list')
                              }, {
                                activator: _withCtx(() => [
                                  _createVNode(AppIcon, {
                                    class: "file-info__add-lists-btn",
                                    name: "plus",
                                    width: "14px",
                                    color: "#979797",
                                    "hover-color": "#499259",
                                    cursor: "pointer",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showAddListSelect.value = true))
                                  })
                                ]),
                                _: 1
                              }, 8, ["text"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(FileInfoListSelect, {
                                "file-id": fileInfo.value?.Id,
                                "added-lists": fileInfo.value?.AnalyticsLists,
                                "show-close-icon": "",
                                onClose: closeAddClientDropdown,
                                onAddList: updateAnalyticLists
                              }, null, 8, ["file-id", "added-lists"])
                            ]),
                            _: 1
                          }, 512),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("file_info_lists")) + ":", 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileInfo.value?.AnalyticsLists, (list) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "file-info__lists-item",
                              key: list.Id
                            }, [
                              _createElementVNode("div", _hoisted_28, _toDisplayString(list.Name), 1),
                              _createVNode(AppIcon, {
                                class: "file-info__lists-item-delete",
                                name: "close",
                                width: "12px",
                                color: "#D2D2D2",
                                "hover-color": "#499259",
                                cursor: "pointer",
                                onClick: ($event: any) => (onDeleteList(list))
                              }, null, 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        permitions: _withCtx(() => [
          _createVNode(FilePermitionsTab, {
            "file-info": filePermitionsInfo.value,
            "rule-access": effectiveRuleAccess.value,
            "entity-id": fileInfo.value?.Id,
            "client-id": _ctx.clientId,
            "project-id": _ctx.projectId,
            "is-folder": typeModalInfo.value !== 'file',
            onSave: save,
            onOpenDropdown: openDropdown,
            onCloseDropdown: closeDropdown
          }, null, 8, ["file-info", "rule-access", "entity-id", "client-id", "project-id", "is-folder"])
        ]),
        additionalContent: _withCtx(() => [
          (hasLimitedAccess.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(AppIcon, {
                  class: "file-info__header-permition-icon",
                  name: "invalid",
                  width: "16px",
                  color: "#979797"
                }),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t(typeModalInfo.value == 'file' ? 'file_limited_access_file' : 'file_limited_access_folder')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["tabs", "modelValue"])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})